import React, { ReactNode } from 'react'

import useCurrentPeriod from 'App/components/CurrentPeriod/useCurrentPeriod'
import Loading from 'App/components/Loading/Loading'

const PeriodContext = React.createContext({} as { id: string; year: number }[])

const CurrentPeriod = ({ children }: { children: ReactNode }) => {
  const { periods } = useCurrentPeriod()

  if (periods?.listPeriods) {
    return <PeriodContext.Provider value={periods.listPeriods}>{children}</PeriodContext.Provider>
  }

  return <Loading />
}

export { CurrentPeriod, PeriodContext }
